import React, { useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function Navbar() {
  const location = useLocation();
  const { isAuthenticated, logoutReal } = useContext(AuthContext);
  const isRealConfigActive = location.pathname === '/real' && new URLSearchParams(location.search).get('tab') === 'config';
  const isRealOverviewActive = location.pathname === '/real' && !isRealConfigActive;
  const isRealOrderActive = location.pathname === '/real/order';
  const brandLabel = 'Real Desk';
  const brandCaption = 'Live broker trading';
  const navLinks = [
    { to: '/real', label: 'Portfolio' },
    { to: '/real/order', label: 'Place Order' },
    { to: '/real?tab=config', label: 'Config' },
  ];
  const isLoggedIn = Boolean(isAuthenticated);
  const actionLabel = 'Connected';
  const loginLink = '/real/login';
  const loginText = 'Connect Kite';
  const handleLogout = logoutReal;

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <NavLink className="brand" to="/real" aria-label={`${brandLabel} home`}>
          <span className="brand-mark brand-mark-chart" aria-hidden="true">
            <span className="brand-mark-bars">
              <i />
              <i />
              <i />
            </span>
            <span className="brand-mark-line" />
          </span>
          <span>
            <strong>{brandLabel}</strong>
            <small>{brandCaption}</small>
          </span>
        </NavLink>
        <nav className="nav-links" aria-label="Primary navigation">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={() => {
                if (link.to === '/real') return isRealOverviewActive ? 'active' : '';
                if (link.to === '/real/order') return isRealOrderActive ? 'active' : '';
                if (link.to === '/real?tab=config') return isRealConfigActive ? 'active' : '';
                return '';
              }}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
        <div className="nav-actions">
          {isLoggedIn ? (
            <>
              <span className="connection-status"><span /> {actionLabel}</span>
              <button onClick={handleLogout} className="button button-ghost button-small">Log out</button>
            </>
          ) : (
            <NavLink to={loginLink} className="button button-light button-small">{loginText}</NavLink>
          )}
        </div>
      </div>
    </header>
  );
}
